import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { DEBIT_CARD_ROUTE_PATHS } from './config';

export const DEBIT_CARD_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-debit-card-transactions',
    path: DEBIT_CARD_ROUTE_PATHS.debitCardTransactions,
    component: lazy(() => import('./pages/debit-card-transactions-page')),
    layout: 'default',
    permissions: { scopes: ['movements-debit-card-transactions'] },
    menu: {
      title: 'pages.movements.debitCardTransactions.title',
    },
  },
];
